// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gradient-background {
   
    background: linear-gradient(to bottom, #2E335A, #1C1B33);
    /* display: flex;
    justify-content: center;
    align-items: center; */
    color: white;
    /* padding: 0px 24px !important; */
  }

  .height-main {
    height: calc(100vh - 65px) !important;
    padding: 0px !important;
  }`, "",{"version":3,"sources":["webpack://./src/components/MainComponent/MainComponent.css"],"names":[],"mappings":"AAAA;;IAEI,wDAAwD;IACxD;;0BAEsB;IACtB,YAAY;IACZ,kCAAkC;EACpC;;EAEA;IACE,qCAAqC;IACrC,uBAAuB;EACzB","sourcesContent":[".gradient-background {\n   \n    background: linear-gradient(to bottom, #2E335A, #1C1B33);\n    /* display: flex;\n    justify-content: center;\n    align-items: center; */\n    color: white;\n    /* padding: 0px 24px !important; */\n  }\n\n  .height-main {\n    height: calc(100vh - 65px) !important;\n    padding: 0px !important;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
